"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PerformerDataSourceContext = void 0;
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var React = __importStar(require("react"));
var PagedDataSource_1 = require("icf-search-client-data/lib/PagedDataSource");
var EqualityComparers_1 = require("icf-search-client-shared/lib/EqualityComparers");
var Contexts_1 = require("../Contexts");
var Ioc_1 = require("../utilities/Ioc");
var ItemRemovalExclusion_1 = require("./ItemRemovalExclusion");
var PerformerDataSourceContextProps_1 = require("./PerformerDataSourceContextProps");
var PerformerDataSourceContext = /** @class */ (function (_super) {
    __extends(PerformerDataSourceContext, _super);
    function PerformerDataSourceContext(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this._itemRemovalExclusion = new ItemRemovalExclusion_1.ItemRemovalExclusion();
        _this._dataSource = _this._createDataSource();
        _this._resultsContextSubscription = _this._dataSource.resultsContext.subscribe(function (resultsContext) {
            if (_this.props.onResultsContextChanged) {
                _this.props.onResultsContextChanged(resultsContext);
            }
            _this.forceUpdate();
        });
        return _this;
    }
    PerformerDataSourceContext.prototype._createDataSource = function () {
        var _this = this;
        var _a = this.props, dataOptions = _a.dataOptions, searchApiClientFactory = _a.searchApiClientFactory;
        var dataProvider = (0, PerformerDataSourceContextProps_1.createDataProvider)(function () { return _this.props.dataOptions; }, searchApiClientFactory.createClient, function () { return _this._itemRemovalExclusion.ids; }, this.props.logger, this.props.dataReceivedCallback);
        var dataUpdateProvider = (0, PerformerDataSourceContextProps_1.createDataUpdateProvider)(searchApiClientFactory.createClient);
        return new PagedDataSource_1.PagedDataSource(dataOptions.itemRange, dataProvider, dataOptions.dataRequestPageSize, dataOptions.cacheTtlMs, dataUpdateProvider);
    };
    PerformerDataSourceContext.prototype.componentDidUpdate = function (prevProps) {
        // TODO: ignore coverage... why?
        /* istanbul ignore if  */
        if (prevProps.user.isAuthenticated !== this.props.user.isAuthenticated) {
            // this makes it so the grid properly updates when the user logs in or out
            this._dataSource = this._createDataSource();
        }
        if (!(0, EqualityComparers_1.deepEqualityComparer)(prevProps.skinConfig, this.props.skinConfig)) {
            // update the grid in Cambuilder sitebuilder when skinConfig changes (e.g. search_boosted_filters)
            this._dataSource = this._createDataSource();
        }
        if (!(0, EqualityComparers_1.rangeEqualityComparer)(this.props.dataOptions.itemRange, this._dataSource.itemRange.value)) {
            this._dataSource.itemRange.value = this.props.dataOptions.itemRange;
        }
        if (!(0, EqualityComparers_1.deepEqualityComparer)(prevProps.user, this.props.user) ||
            !(0, EqualityComparers_1.deepEqualityComparer)(prevProps.dataOptions.queryOptions, this.props.dataOptions.queryOptions)) {
            this._dataSource.reset();
        }
    };
    PerformerDataSourceContext.prototype.componentWillUnmount = function () {
        this._resultsContextSubscription.dispose();
        this._dataSource.dispose();
    };
    PerformerDataSourceContext.prototype.render = function () {
        return (React.createElement(Ioc_1.ContextProvider, { contexts: [
                [Contexts_1.IDataSourceContext, this._dataSource],
                [Contexts_1.IItemRemovalExclusionContext, this._itemRemovalExclusion],
            ] }, this.props.children(this._dataSource)));
    };
    PerformerDataSourceContext = __decorate([
        (0, Ioc_1.connectContextsToProps)({
            searchApiClientFactory: Contexts_1.ISearchApiClientFactoryContext,
            user: Contexts_1.IUserContext,
            skinConfig: Contexts_1.ISearchSkinConfigContext,
            logger: Contexts_1.ILoggerContext,
        })
    ], PerformerDataSourceContext);
    return PerformerDataSourceContext;
}(React.PureComponent));
exports.PerformerDataSourceContext = PerformerDataSourceContext;
//# sourceMappingURL=PerformerDataSourceContext.js.map